import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider, Divider, Image, Tooltip } from "antd";
import { getTotalPriceOfSelectedItems } from "../../services/order-common-service";

function OrderMealAdditionModal({ openModal, foodQuantity, additionGroups, onSaveAdditionGroups, setIsGroupsModalOpen }) {
  const [groups, setGroups] = useState([]);
  

  const onChangeQuantity = (additionGroupId, additionItemId, isIncrement) => {
    setGroups((prevGroups) =>
      prevGroups.map((group) => {
        if (group.additionGroupId === additionGroupId) {
          // Update items inside the group
          const updatedItems = group.additionItems.map((item) => {
            if (item.additionItemId === additionItemId) {
              let newQuantity = item.quantity;
              if (isIncrement) {
                newQuantity += 1;
              } else {
                // Prevent going below 0
                newQuantity = Math.max(0, newQuantity - 1);
              }
              return { ...item, quantity: newQuantity };
            }
            return item;
          });
          
           // Check if any item has quantity > 0
        const isSelected = updatedItems.some((item) => item.quantity > 0);
          // Recalculate total price for the group
          const totalPriceOfSelectedItems = getTotalPriceOfSelectedItems(group, updatedItems, foodQuantity);

          return {
            ...group,
            isSelected,
            additionItems: updatedItems,
            totalPriceOfSelectedItems: totalPriceOfSelectedItems.toFixed(2),
          };
        }

        return group;
      })
    );
  };

  const onModalClose = () => {
    setIsGroupsModalOpen(false);
    setGroups(additionGroups)
  }

  const onSave = () => {
    onSaveAdditionGroups(groups);
    setIsGroupsModalOpen(false);
  };

  useEffect(() => {
    const tmp = [...additionGroups];
    setGroups(tmp);
    console.log("*************OrderMealAdditionModal***** [additionGroups]*****", { additionGroups });
  }, [additionGroups]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        width={550}
        maskClosable={false}
        open={openModal}
        onOk={onSave}
        onCancel={() => onModalClose()}
        title={<span className="text-xl font-bold">Meal Addition</span>}
        footer={[
          <button
            key="decline"
            onClick={() => onModalClose()}
            style={{
              backgroundColor: "#FF4D4F",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Cancel
          </button>,
          <button
            key="ok"
            onClick={onSave}
            style={{
              backgroundColor: "#FFD700",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Save
          </button>,
        ]}
        styles={{ body: { paddingTop: "0px" } }}
      >
        <div className="flex flex-col font-uregular">
          <Divider style={{ margin: "5px 0" }} />
          <div className="flex flex-col">
            {groups.map((group, groupIndex) => (
              <div key={group.additionGroupId} className="mb-6">
                {/* Group Header */}
                <div className="flex justify-between items-start w-full">
                  <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-[14px]">{group.name}</h3>
                    <p className="text-[12px] text-gray-500">
                      Select any {group.numberOfFreeItems === 0 ? 'item' : group.numberOfFreeItems * foodQuantity} [{group.numberOfFreeItems > 0 ?'Complimentary' : `${group.pricePerAddition} TK/Item` }]
                    </p>
                  </div>
                  <div className="flex items-start gap-1 shrink-0 ml-2">
                    <span className="text-red-500 font-bold">
                      {getTotalPriceOfSelectedItems(group, group.additionItems, foodQuantity) === 0  && group.numberOfFreeItems > 0? "Free" : `${(getTotalPriceOfSelectedItems(group, group.additionItems, foodQuantity)).toFixed(2)} TK`}
                    </span>
                    <div>
                      <Tooltip title={`Upto ${group.numberOfFreeItems} items free. Additional items will be charged ${group.pricePerAddition} TK each.`}>
                        <div className="text-white w-5 h-5 bg-yellow rounded-full flex items-center justify-center cursor-pointer">
                          i
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>

                {/* Items */}
                <div className="mt-2">
                  {group.additionItems.map((item, itemIndex) => (
                    <div
                      key={item.additionItemId}
                      className="flex justify-between items-center bg-gray-100 rounded-lg px-3 py-2 mb-2"
                    >
                      <span className="text-[14px] font-medium break-words whitespace-normal flex-1 min-w-0">{item.name}</span>
                      <div className="flex items-center gap-2">
                        <div className="flex items-center space-x-[5px]">
                          {/* quantity */}
                          <div className="flex items-center space-x-[5px]">
                            <button
                              className="h-[20px] w-[20px] rounded-full flex items-center justify-center bg-[#C3D61B]"
                              onClick={() => onChangeQuantity(group.additionGroupId, item.additionItemId, false)}
                            >
                              <Image
                                src="/images/icons/minus_sign.svg"
                                preview={false}
                                alt="close"
                                height={14}
                                width={14}
                              />
                            </button>
                            <span className="pl-1 pr-1">{item.quantity}</span>
                            <button
                              className="h-[20px] w-[20px] rounded-full flex items-center justify-center bg-[#572D86]"
                              onClick={() => onChangeQuantity(group.additionGroupId, item.additionItemId, true)}
                            >
                              <Image
                                src="/images/icons/plus_sign.svg"
                                preview={false}
                                alt="close"
                                height={14}
                                width={14}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <Divider style={{ margin: 0 }} />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default OrderMealAdditionModal;
